"use client";

import { useAppContext } from "@/app/(main)/_components/AppProvider";
import { ChevronLeft, Inventory2Outlined } from "@mui/icons-material";
import { Box, Button, Card, Stack, Typography, useScrollTrigger } from "@mui/material";

function scrollToRelatedProducts() {
  const el = document.getElementById("related");
  if (!el) return;

  const offset = 80;
  const y = el.getBoundingClientRect().top + window.scrollY - offset;
  window.scrollTo({ top: y, behavior: "smooth" });
}

export default function NoVariantsSection() {
  const trigger = useScrollTrigger();
  const { hasBanner, bannerOptions } = useAppContext();

  return (
    <>
      <Box component="span" sx={{ display: "none" }} data-stock={false}>
        OutOfStock
      </Box>
      <Card
        component="section"
        aria-label="وضعیت موجودی"
        elevation={0}
        sx={{
          position: { xs: "relative", lg: "sticky" },
          top: {
            lg: trigger
              ? `${88 + (hasBanner ? bannerOptions.sx.minHeight.sm : 0)}px`
              : `${158 + (hasBanner ? bannerOptions.sx.minHeight.sm : 0)}px`,
          },
          width: "100%",
          overflow: "hidden",
          borderRadius: 3,
          border: "1px solid",
          borderColor: "secondary.200",
          background: "linear-gradient(180deg, #FFF7F0 0%, #FFFFFF 72%)",
          boxShadow: { xs: "none", lg: "0 8px 28px rgba(33, 33, 33, 0.06)" },
          p: { xs: 1.75, sm: 2.25 },
        }}
      >
        <Stack
          direction={{ xs: "column", md: "row", lg: "column" }}
          spacing={{ xs: 2, md: 2.5, lg: 2.25 }}
          alignItems={{ xs: "stretch", md: "center", lg: "stretch" }}
          justifyContent="space-between"
        >
          <Stack direction="row" spacing={1.5} alignItems="flex-start" sx={{ minWidth: 0, flex: 1 }}>
            <Box
              aria-hidden
              sx={{
                width: 48,
                height: 48,
                flexShrink: 0,
                borderRadius: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "secondary.100",
                color: "secondary.800",
              }}
            >
              <Inventory2Outlined />
            </Box>
            <Box sx={{ minWidth: 0 }}>
              <Typography
                component="p"
                sx={{
                  m: 0,
                  mb: 0.75,
                  display: "inline-flex",
                  alignItems: "center",
                  px: 1,
                  py: 0.2,
                  borderRadius: 50,
                  bgcolor: "secondary.100",
                  color: "secondary.900",
                  fontWeight: 800,
                  fontSize: "0.75rem",
                  lineHeight: 1.7,
                }}
              >
                ناموجود
              </Typography>
              <Typography
                component="h2"
                sx={{ m: 0, fontWeight: 800, fontSize: { xs: "1rem", sm: "1.0625rem" }, lineHeight: 1.7, color: "grey.900" }}
              >
                این کالا فعلاً موجود نیست
              </Typography>
              <Typography sx={{ mt: 0.35, color: "grey.700", fontSize: "0.85rem", lineHeight: 1.85 }}>
                موجودی این کالا تمام شده است. برای ادامه خرید، کالاهای مشابه را ببینید.
              </Typography>
            </Box>
          </Stack>

          <Button
            variant="contained"
            disableElevation
            onClick={scrollToRelatedProducts}
            endIcon={<ChevronLeft />}
            sx={{
              flexShrink: 0,
              alignSelf: { xs: "stretch", md: "center", lg: "stretch" },
              width: { xs: "100%", md: "auto", lg: "100%" },
              minWidth: { md: 220, lg: 0 },
              height: 46,
              px: 2.5,
              borderRadius: 2,
              bgcolor: "grey.900",
              fontWeight: 800,
              whiteSpace: "nowrap",
              "&:hover": { bgcolor: "grey.800" },
            }}
          >
            مشاهده کالاهای مشابه
          </Button>
        </Stack>
      </Card>
    </>
  );
}
